export default "__VITE_ASSET__e39fa126__"